module.exports = __webpack_public_path__ + "8b307a547893e96623f207a4117ee854.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/ripped-jeans.png
// module id = 1929
// module chunks = 0